import axios from 'axios';

export function setDefaultAuthorizationHeader() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`; // for all requests
}

export function removeDefaultAuthorizationHeader() {
    axios.defaults.headers.common['Authorization'] = null; // for all requests
}
